import * as Yup from "yup";

export class GestoraEnergiaSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
    } = recordShape;

    const createFormShape = {
      nome: nome.required("Nome é obrigatório"),
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
    } = recordShape;

    const updateFormShape = {
      nome,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  nome: Yup
    .string(),
};
